<template>
  <div id="chatbot" class="bot-content"
       :class="{'splash': settings.splashScreen && !settings.hasSplashed}">
    <!-- CONTAINER: chat container with slider -->
    <div class="bot-content__chat-container">
      <!-- SUBHEADER: contains settings -->
      <Subheader :key="showTooltip" :activateTooltip="showTooltip" @dialogicPlatformReset="initializeConversation()"/>
      <div class="bot-content__slider"
           @wheel="preventDefaultScrollOnChat">
        <div class="bot-content__wrapper">
          <div v-if="settings.hasSplashed"
               class="bot-content__date">
            {{ chatData.date }}
          </div>
          <Message
              v-for="message in messages"
              :key="message.id"
              :messages-count="message.messagesCount"
              :messages-index="message.messagesIndex"
              :text="message.text"
              :type="message.type"
              :options="message.options"
              :callback="sendMessageFromElement"
              :started="settings.hasSplashed">
          </Message>
          <Message v-if="chatData.loading"
                   type="loader">
          </Message>
        </div>
      </div>
    </div>

    <!-- OUTER MENU: not working for now - not useful -->
    <div v-if="settings.outerMenu && settings.showOuterMenu"
         class="bot-content__outer-menu"
         @click="settings.showOuterMenu=false">
      <menu-bot :show="settings.outerMenu && settings.showOuterMenu"
                :callback="sendMessageFromElement">
      </menu-bot>
    </div>

    <!-- MESSAGE SENDER: user input bar -->
    <div v-if="settings.hasSplashed"
         class="bot-content__input">
      <!-- TELEGRAM QRCODE -->
      <!--<div class="text-xs-center" v-show="!chatState.recording.isActive">
          <v-bottom-sheet inset>
              <template v-slot:activator>
                  <v-btn icon dark color="blue lighten-1" @click="resetInstantMessagingQRCodeVariables()">
                      <v-icon>mdi-qrcode</v-icon>
                  </v-btn>
              </template>
              <v-card tile>
                  <v-layout row wrap>
                      <v-flex xs8>
                          <v-list>
                              <v-subheader>Connect with our instant messaging channels</v-subheader>
                              <v-list-tile v-for="instantMessagingChannel in instantMessaging.instantMessagingChannels"
                                           :key="instantMessagingChannel.title"
                                           @click="showInstantMessagingQRCode(instantMessagingChannel.title)">
                                  <v-list-tile-avatar>
                                      <v-avatar size="32px" :color="instantMessagingChannel.color">
                                          <v-icon dark>{{ instantMessagingChannel.icon }}</v-icon>
                                      </v-avatar>
                                  </v-list-tile-avatar>
                                  <v-list-tile-title>{{ instantMessagingChannel.title }}</v-list-tile-title>
                              </v-list-tile>
                          </v-list>
                      </v-flex>
                      <v-flex class="pa-2" xs4 v-if="instantMessaging.instantMessagingQRCode">
                          <p class="subheading pa-3"><strong>{{ instantMessaging.instantMessagingTitle }}</strong></p>
                          <v-img v-if="qrCode!==''" :src="qrCode"></v-img>                            </v-flex>
                  </v-layout>
              </v-card>
          </v-bottom-sheet>
      </div>-->
      <v-autocomplete
          v-if="showAutocomplete && !userChatbotSettings.buttons"
          v-model="userRequest.text"
          :items="itemsAutocomplete"
          color="rgb(0,0,0,0)"
          autofocus
          hide-no-data
          hide-selected
          :placeholder="settings.userInput.placeholder"
          return-object
          class="bot-content__input__text"
          @keyup.enter="sendMessage()"

      ></v-autocomplete>
      <input v-else
             v-model="userRequest.text"
             type="text"
             class="bot-content__input__text"
             :placeholder="settings.userInput.placeholder"
             @keyup.enter="sendMessage()">
      <v-btn icon color="primary" @click="sendMessage()" class="mr-0">
        <v-icon color="white">mdi-send</v-icon>
      </v-btn>
      <v-tooltip color="amber lighten-4" top>
        <template v-slot:activator="{ on }">
          <v-btn icon
                 color="orange darken-4"
                 @click="sendMessage((userSettings.chatbot.language.current.locale === 'it') ? 'aiuto' : 'help')"
                 class="mr-0"
                 v-on="on">
            <v-icon color="white">mdi-help</v-icon>
          </v-btn>
        </template>
        <v-card color="amber lighten-4" elevation="0">
          <v-card-title>
            <v-layout column wrap>
              <v-flex>
                <span v-if="userSettings.chatbot.language.current.locale === 'it'" class="subheading">Clicca per ricevere suggerimenti sul funzionamento di NTT DATA Discovery.</span>
                <span v-else class="subheading">Click to receive suggestions on how NTT DATA Discovery works.</span>
              </v-flex>
            </v-layout>
          </v-card-title>
        </v-card>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import UrlsService from "@/helpers/UrlsService.js";
import APIService from "@/helpers/APIService.js";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService.js";
import TextService from "@/helpers/TextService";
import FileService from "@/helpers/FileService";
import TimeService from "@/helpers/TimeService";

import Message from "./Message.vue";
import MenuBot from "./MenuBot.vue";
import Subheader from "./Subheader";
import SubmitButton from "./SubmitButton.vue";
import ChatbotPanel from "./ChatbotPanel";
import AudioInput from "../Inputs/Audio/AudioInput";
import AudioRecorder from "../Inputs/Audio/AudioRecorder";

export default {
  name: "Chatbot",
  components: {
    AudioRecorder,
    AudioInput,
    ChatbotPanel,
    Subheader,
    Message,
    MenuBot,
    SubmitButton,
  },
  data() {
    return {
      showAutocomplete: false,
      itemsAutocomplete: [],
      showTooltip: false,
      qrCode: "",
      instantMessaging: {
        instantMessagingChannels: [
          {
            title: 'Telegram',
            color: 'blue lighten-1',
            icon: 'mdi-telegram'
          }
        ],
        instantMessagingDial: false,
        instantMessagingTitle: "",
        instantMessagingQRCode: false,
      },
      openSettings: false,
      openChatbotPanel: false,
      chatData: {
        date: "", // the date (and hour) in which the chat started
        loading: false, // true if the system is waiting for the answer.
        requestIndex: 1,
        queueMsg: 0,
      },
      userRequest: {
        text: "",  // text is the query the user provides to the chatbot
      },
      requestFeedback: false,
      idfeedback: null,
      images: null,
    };
  },
  computed: {
    ...mapState({}),
    ...mapGetters("ChatbotState", {
          settings: "getSettings",
          messages: "getMessages",
          defaultMessages: "getDefaultMessages",
          userChatOptions: "getUserChatOptions",
          chatState: "getChatState",
        }
    ),
    ...mapGetters("UserState", {
          userOptions: "getUserOptions",
          userSettings: "getSettings",
        },
    ),
    ...mapGetters("AppState", {
          userChatbotSettings: "getSettings",
        },
    ),
  },
  mounted() {

    // Automatic adjusting position
    this.fitPosition();
    // Getting starting chat date
    let days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun",];
    let d = new Date();
    let hour = d.getHours();
    hour = (hour < 10) ? "0" + hour : hour;
    let min = d.getMinutes();
    min = (min < 10) ? "0" + min : min;
    this.chatData.date = days[d.getDay() - 1] + " " + hour + ":" + min;

    // event starts when all message response are rendered
    /*let _this = this;
    vm.$on("renderedAllMessage", function () {
        if (_this.requestFeedback) {
            setTimeout(function () {
                //_this.pushMessage(_this.feed);
                _this.requestFeedback = false;
            }, 10);
        }
    });*/
  },
  created() {
    this.getQRCode();
    // Initialize Conversation if it's the first time that the component is created
    if (this.settings.toBeInitialized === true) {
      this.initializeConversation();
      this.settings.toBeInitialized = false;
      this.$store.dispatch("ChatbotState/setSettings", this.settings);
    }
  },
  methods: {
    getQRCode() {
      let requestUrl = {
        url: UrlsService.getQRCode,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {},
      };
      let requestObject = {
        type: "normal",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };

      let messages = {
        title: "Generation of QRCode",
        loading: "Waiting for QR Code...",
        error: "Cannot complete the generation of QR Code...",
      };
      let options = {
        loadingType: "none",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            if (responseSuccess.response.binaryData !== undefined) {
              this.qrCode = "data:image/png;base64," + responseSuccess.response.binaryData;
            }

          })
    },
    setStartRecording() {
      this.chatState.recording.isActive = true;
      this.$store.dispatch("ChatbotState/setChatState", this.chatState);
    },
    setStopRecording() {
      this.chatState.recording.isActive = false;
      this.$store.dispatch("ChatbotState/setChatState", this.chatState);
    },
    sendVoiceMessage(blob) {
      let text = "";
      let audio = URL.createObjectURL(blob);
      // Creating request json and get the url
      let requestUrl = {
        url: UrlsService.speechToText, // "http://10.175.76.19:5000/speechToText", TODO be
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        interactionData: {
          language: this.userSettings.chatbot.audio.language.current.name
        },
      };
      let requestObject = {
        type: "upload",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
          file: blob,
        },
      };
      let messages = {
        title: "Speech To Text",
        loading: "Waiting for speech recognition...",
        error: "Cannot complete the speech recognition...",
      };
      let options = {
        loadingType: "notification",
        timeout: TimeService.secondsToMillis(60),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            // Process and Render the response
            text = responseSuccess.text;
            this.sendMessage(text, false, audio);
          }).catch(responseError => {
      });
    },
    resetInstantMessagingQRCodeVariables() {
      this.instantMessaging.instantMessagingQRCode = false;
      this.instantMessaging.instantMessagingTitle = "";
    },
    showInstantMessagingQRCode(title) {
      this.instantMessaging.instantMessagingQRCode = true;
      this.instantMessaging.instantMessagingTitle = title;
    },
    /**
     * toggleSettings
     */
    toggleSettings() {
      //his.openSettings = true;
    },
    initializeConversation() {
      // Clear message history
      this.$store.dispatch("ChatbotState/setMessages", []);
      // Clear user contextId
      this.userOptions.contextId = ""; // conversationId
      this.$store.dispatch("UserState/setUserOptions", this.userOptions);
      // Send "startConversationMessage" to engage the conversation, if it has already splashed
      this.sendMessage(this.defaultMessages.startConversation.text, 1);
    },
    /**
     * fitPosition
     * Adjust UI position and scroll automatically
     */
    fitPosition() {
      setTimeout(() => {
        let container = this.$el.querySelector(".bot-content__slider");
        container.scrollTop = container.scrollHeight;
      }, 250);
    },
    /**
     * preventDefaultScrollOnChat
     * Deny the default scroll method. It allows to scroll only the messages of the chat.
     */
    preventDefaultScrollOnChat(e) {
      if (e.wheelDeltaY !== 0 && (Math.abs(e.wheelDeltaY) > Math.abs(e.wheelDeltaX))) {
        let d = e.wheelDeltaY;
        if (d > 60) {
          d = 60;
        }
        if (d < -60) {
          d = -60;
        }
        e.currentTarget.scrollTop += d * -1; //( d < 0 ? 1 : -1 ) * 30;
        e.preventDefault();
      }
    },
    /**
     * toggleOuterMenu:
     * Open / Close the menu with suggestions - not used for now
     */
    toggleOuterMenu(value) {
      this.settings.showOuterMenu = value;
      this.$store.dispatch("ChatbotState/setSettings", settings);
    },
    /**
     * sendMessageFromElement:
     * Take the element and calls the send message by taking the "text" field
     * of the element
     */
    sendMessageFromElement(element) {
      if (element) {
        this.sendMessage(element.text, false);
      }
    },
    /**
     * sendMessage:
     * Send message to the backend services.
     * It first operates a text elaboration in order to clean the message and enrich it
     * with bold, italic, images and links. Then it calls the backend for retrieving
     * the response message.
     */
    sendMessage(text, first, audio, action, hideMessage) {
      this.userRequest.text = this.$sanitize(this.userRequest.text);
      if (text) text = this.$sanitize(text);
      if (this.userRequest.text.replace(/ /g, "").length > 0 || text) {
        this.showAutocomplete = false;
        this.userRequest.text = text || this.userRequest.text;

        // Set type of message
        let type = "request";
        if (!this.settings.hasSplashed) {
          type = "start";
          this.settings.hasSplashed = true;
          this.$store.dispatch("ChatbotState/setSettings", this.settings);
        }
        let textMessage = this.userRequest.text;
        textMessage = TextService.goUpperCaseFirst(textMessage);
        textMessage = TextService.replaceBold(textMessage);
        textMessage = TextService.replaceItalic(textMessage);
        textMessage = TextService.replaceLinks(textMessage);
        textMessage = TextService.replaceImages(textMessage);
        let userMessage = {
          text: textMessage,
          type: type,
          options: {
            audio: audio
          }
        };
        // Update messages variable putting the one sent by the user
        if (!first) {
          this.pushMessage(userMessage);
        }

        // Automatic adjusting position
        this.fitPosition();

        // Setting timeout for answer receiving
        let _this = this;
        setTimeout(function () {
          _this.chatData.loading = true;
          _this.fitPosition();
        }, 1000);

        // Call Backend through POST
        //let clearedText = TextService.clearText(this.userRequest.text);
        let clearedText = this.userRequest.text;
        this.userRequest.text = "";
        // Creating request json and get the url
        let requestUrl = {
          url: this.userSettings.chatbot.enableAdvanced.current ? UrlsService.doAdvancedAsk : UrlsService.doAsk,
          timeout: TimeService.secondsToMillis(0),
        };
        let requestBody = {
          interactionData: {
            text: clearedText,
            language: this.userSettings.chatbot.language.current.locale,
            dialogicInteractionRequest: {
              language: this.userSettings.chatbot.language.current.locale,
              interactionMode: this.userChatOptions.interactionMode,
            },
            elasticSearchRequest: {
              query: "SEMANTIC",
            },
          },
        };
        APIService.execute(requestUrl, requestBody)
            .then(responseSuccess => {
              // Process and Render the response
              let _this = this;
              setTimeout(function () {
                _this.preprocessResponse(responseSuccess);
                _this.showTooltip = responseSuccess.response.dialogicAdditionalInfo.activateTooltipResults;
                _this.showAutocomplete = responseSuccess.response.dialogicAdditionalInfo.activateAutocomplete;

                _this.userChatOptions.activateTooltip = responseSuccess.response.dialogicAdditionalInfo.activateTooltipResults;
                _this.$store.dispatch("ChatbotState/setUserChatOptions", _this.userChatOptions);
              }, 1000);
            })
            .catch(responseError => {
              // No backend connection, or other errors
              console.error("FILES.FINDER:", responseError);
              for (let i = 0; i < this.defaultMessages.noBackendConnection.length; i++) {
                this.pushMessage(this.defaultMessages.noBackendConnection[i]);
              }
            });
      }
    },
    /**
     * preprocessResponse
     * This is a function that provides some basic preprocessing functionalities as:
     *   - transform response from string to json if needed,
     *
     *   - handle
     */
    preprocessResponse(responseBody) {
      // Parse the response if it is a string
      if (typeof responseBody === "string") {
        responseBody = JSON.parse(responseBody);
      }

      // Get the response and update the conversationId if it is not empty
      let response = responseBody.response;
      if (response) {
        // Set the contextId if it is null or empty. Otherwise use the old contextId
        if (this.userOptions.contextId === undefined || this.userOptions.contextId === "") {
          this.userOptions.contextId = response.conversationId;
          this.$store.dispatch("UserState/setUserOptions", this.userOptions);
        }
        this.processResponse(response);
      } else {
        // no answer response: continue loading
        this.chatData.loading = true;
        this.pushMessage(this.defaultMessages.noBackendAnswer);
        this.chatData.loading = false;
      }
    },

    /**
     * processResponse:
     * This function follows the following step to process and enrich the message.
     *  MESSAGE PROCESSING:
     * 1. Get all the enrichment objects
     *    1.1. Analyze the information from the fields itemContainer and fileResults (I.R.)
     *    1.1. Parse the objects and put it in the data fields
     * 2. Split the messages
     *    2.1. Text processing: link, images, bold and italic
     *    2.2. Put the enrichment objects in the last message
     */
    processResponse(response) {
      this.chatData.requestIndex = this.chatData.requestIndex + 1;
      this.chatData.queueMsg = 0;
      let answer = response.answer || "";

      /*let itemContainer = {
              type: 1,
              description: 'Static Item Container',
              items: [
                  {
                      type: 1, //card,
                      itemType: 'links',
                      description: 'Card with elements',
                      components: [
                          {
                              type: 1, // button
                              text: 'Test prova',
                              value: 'Test prova',
                          },
                          {
                              type: 3, // link
                              text: 'https://www.google.it/',
                              value: 'https://www.google.it/',
                          },
                          {
                              type: 4, // image
                              text: 'https://data.whicdn.com/images/316789848/original.jpg?t=1532765695',
                              value: 'https://data.whicdn.com/images/316789848/original.jpg?t=1532765695',
                          },
                          {
                              type: 5, // video
                              text: 'https://www.youtube.com/watch?v=yp4WEDgmUFQ&list=RDyp4WEDgmUFQ&start_radio=1',
                              value: 'https://www.youtube.com/watch?v=yp4WEDgmUFQ&list=RDyp4WEDgmUFQ&start_radio=1',
                          }
                      ],
                  }
              ],
          };
          response.itemContainer = itemContainer;*/
      /*let enrichment = {
              image: '', //'https://data.whicdn.com/images/316789848/original.jpg?t=1532765695',
              links: [
                  {text: "https://www.google.it/", url: "", action: ""},
                  {text: "No", url: "", action: ""}
              ],
              video: '',//https://www.youtube.com/watch?v=yp4WEDgmUFQ&list=RDyp4WEDgmUFQ&start_radio=1',
              buttons: [{text: 'Prova'}, {text: 'Test'}],
              elastic: '',
              images: ''
          };*/


      // 1. Get all the enrichment objects
      let enrichments = this.buildEnrichments();
      enrichments = this.enrichAnswerFromText(response, enrichments);
      if (response.itemContainer !== undefined) {
        enrichments = this.enrichAnswerByItems(response, enrichments);
      }
      if (response.searchResults !== undefined) {
        if (response.searchResults.length > 0) {
          if (answer === "") {
            if (this.userSettings.chatbot.language.current.locale === "it") {
              answer = "Ecco a te:";
            } else {
              answer = "Here you are:";
            }

          }
          enrichments = this.enrichAnswerByInformationRetrieval(response, enrichments);
        } else {
          if (this.userSettings.chatbot.language.current.locale === "it") {
            answer = "Nessun documento trovato.";
          } else {
            answer = "No documents found.";
          }

        }
      }

      // 2. Split the messages
      let messages = answer.split("#br#");
      let messagesLength = messages.length;
      for (let i = 0; i < messagesLength; i++) {
        let messageText = messages[i].trim();
        messageText = TextService.goUpperCaseFirst(messageText);
        messageText = TextService.replaceBold(messageText);
        messageText = TextService.replaceItalic(messageText);
        messageText = TextService.replaceLinks(messageText);
        messageText = TextService.replaceImages(messageText);
        messageText = TextService.replaceButtons(messageText);
        messageText = TextService.replaceSpecialButtons(messageText);
        messageText = TextService.replaceCards(messageText);
        messageText = TextService.replacePiecharts(messageText);
        messageText = TextService.createPanelButton(messageText, (value) => {

        });
        let messageChild = {
          type: "response",
          text: messageText,
          options: { // put options data only in the last message:  messages.length - 1)
            image: (i === messages.length - 1) ? enrichments.image : "",
            video: (i === messages.length - 1) ? enrichments.video : "",
            audio: (i === messages.length - 1) ? enrichments.audio : "",
            links: (i === messages.length - 1) ? enrichments.links : [],
            buttons: (i === messages.length - 1) ? enrichments.buttons : [],
            files: (i === messages.length - 1) ? enrichments.files : [],
            images: (i === messages.length - 1) ? enrichments.images : [],
            piecharts: (i === messages.length - 1) ? enrichments.piecharts : [],
          },
        };
        // Push messages
        this.chatData.loading = true;
        this.pushMessage(messageChild, false, (i !== messagesLength - 1), messagesLength, i + 1);

        // Check for end of conversation
        if (response.endConversation) {
          this.messages.push({type: 'meta', options: {type: 'divider'}, text: 'End of conversation'});
          this.$store.dispatch("ChatbotState/setMessages", this.messages);
        }
      }
    },
    buildEnrichments() {
      let enrichments = {
        image: "",
        video: "",
        audio: "",
        links: [],
        buttons: [],
        files: [],
        images: [],
        cards:[],
        piecharts:[],
      };
      return enrichments;
    },
    /**
     * enrichAnswerByItems
     * This function takes the response and the enrichments and enrich the enrichments
     * through the itemContainer found in the response object. The itemContainer
     * is a structure that can contains some different kind of object such as
     * link, video, audio, images with several kind of organizations: 'box', 'multiChoice',
     * 'cards', etc. The output is the enrichments enriched with additional information.
     */
    enrichAnswerByItems(response, message) {
      let cards = [];
      let links = [];
      if (response.itemContainer.items !== null && response.itemContainer.items.length > 0) {
        for (let i = 0; i < response.itemContainer.items.length; i++) {
          if (response.itemContainer.items[i].itemType === "box") {
            // BOX: card or multiple card or generic element
            let card = {
              text: response.answer,
              options: {
                image: null,
                links: [],
              },
            };
            for (let j = 0; j < response.itemContainer.items[i].components.length; j++) {
              let l = {text: response.itemContainer.items[i].components[j].value,};
              card.options.links.push(l);
            }
            cards.push(card);
          } else if (response.itemContainer.items[i].itemType === "multiChoice") {
            // MULTICHOICE
            let j;
            for (j = 0; j < response.itemContainer.items[i].components.length; j++) {
              let l = {label: response.itemContainer.items[i].components[j].value,};
              links.push(l);
            }
            if (j < 4) {
              resp.options["links"] = links;
            } else {
              resp.options["buttons"] = links;
            }
          } else if (response.itemContainer.items[i].itemType === "links") {
            // LINKS
            for (let j = 0; j < response.itemContainer.items[i].components.length; j++) {
              answer = answer.replace("#link#", "<a href=\"" + response.itemContainer.items[0].components[0].value + "\" target=\"_blank\">" + "sito" + "</a>");
            }
          }
        }
        if (cards.length > 0) {
          let cardMessage = {
            type: "response",
            text: response.answer,
            options: {
              image: "",
              link: links,
              video: "",
              audio: "",
              buttons: "",
              files: "",
              images: "",
              cards: cards,
            },
          };
        }
      }
      return message;
    },
    /**
     * enrichAnswerFromText
     */
    enrichAnswerFromText(response, enrichments) {
      if (response.answer !== undefined) {
        this.itemsAutocomplete = [];

        let specialButtons = TextService.getSpecialButtonsFromText(response.answer);
        if (specialButtons !== undefined && specialButtons != null) {
          for (let i = 0; i < specialButtons.length; i++) {
            enrichments.buttons.push({text: specialButtons[i], type: "special"});
          }
        }

        let buttons = TextService.getButtonsFromText(response.answer);
        if (buttons !== undefined && buttons != null) {
          console.log('b', buttons)
          for (let i = 0; i < buttons.length; i++) {
            if (buttons[i] === '')
              buttons.splice(i, 1)
            enrichments.buttons.push({text: buttons[i], type: "normal"});
            this.itemsAutocomplete.push(buttons[i]);
          }
        }

        let cards = TextService.getCardsFromText(response.answer);
        if (cards !== undefined && cards != null) {
          for (let i = 0; i < cards.length; i++) {
            enrichments.cards.push(cards[i]);
          }
        }

        let piecharts = TextService.getPiechartsFromText(response.answer);
        if (piecharts !== undefined && piecharts != null) {
          for (let i = 0; i < piecharts.length; i++) {
            enrichments.piecharts.push(piecharts[i]);
          }
        }
      }

      return enrichments;
    },
    /**
     * enrichAnswerByInformationRetrieval
     * This function takes the response and the enrichments and enrich the message
     * through the files information found in the response object.
     * The output is the enrichments enriched with additional information.
     */
    enrichAnswerByInformationRetrieval(response, enrichments) {
      let files = [];
      if (response.searchResults !== undefined) {
        for (let i = 0; i < response.searchResults.length; i++) {
          let file = {
            filename: response.searchResults[i].file.filename,
            version: response.searchResults[i].file.version,
            image: FileService.computeImageByExt(response.searchResults[i].file.extension),
          };
          files.push(file);
        }
      }
      enrichments.files = files;
      return enrichments;
      /*if (response.action != null) {
              if (response.action.includes("[url]")) {
                  let elastic = [];
                  let name = response.action.substring(5, response.action.length);
                  let url = "./doc/" + name;
                  let imagePath = "./doc/docx.png";
                  console.log('url: ', url);
                  let lelastic = {"image": imagePath, "location": url, "title": name};
                  elastic.push(lelastic);
                  resp.options['elastic'] = elastic;
              }
          }*/
    },

    /*retriveLinkData(resp, hasImage) {
            let _this = this;
            _this.$http.get(resp.options.link).then(success => {
                var el = document.createElement('html');
                el.innerHTML = success.body;
                let title = el.getElementsByTagName('title')[0].text;

                var imageMeta = el.querySelector('meta[property="og:image"]');
                var altImage = !imageMeta;
                var image = imageMeta && imageMeta.getAttribute("content");

                var descriptionMeta = el.querySelector('meta[name="description"]');
                var description = descriptionMeta && descriptionMeta.getAttribute("content");

                resp.options.preview = {
                    title,
                    description,
                    image,
                    altImage
                };
                _this.loading = true;
                _this.pushMessage(resp, hasImage);
            }, error => {
                console.error("retrieveLinkData error");
                return {};
            });
        },*/

    pushMessage(obj, scrollDelay = false, bypassLoading = false, messagesCount, messagesIndex, feed = false) {
      let thisObj = {...obj, messagesCount, messagesIndex};
      this.chatData.queueMsg = this.chatData.queueMsg + 1;
      this.messages.push(thisObj);
      this.$store.dispatch("ChatbotState/setMessages", this.messages);
      this.fitPosition();
      if (scrollDelay) {
        let _this = this;
        setTimeout(function () {
          _this.fitPosition();
        }, 750);
      }
      if (!bypassLoading) {
        this.chatData.loading = false;
      }
    },


  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/scss/chatbot/commons";

$header-height: 60px;
$input-height: 50px;
$chat-max-width: 840px;

.bot-content {
  height: 90vh;
  font-family: $font-book;
  margin: 0;
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;

  @include e("header") {
    height: 60px;
    margin: 0;
    background: #fff;
    position: relative;
    overflow: hidden;
    box-shadow: 0px -10px 60px rgba(130, 156, 222, .4);
    z-index: 3;
    @include e("logo") {
      position: absolute;
      top: 17px;
      left: 15px;
      width: 37px;
    }
    @include e("close") {
      position: absolute;
      top: 23px;
      right: 15px;
      line-height: 15px;
    }
    .splash & {
      box-shadow: none;
    }
  }
  @include e("outer-menu") {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
  }
  @include e("chat-container") {
    height: calc(100% - #{$input-height});
  }
  @include e("slider") {
    @include clearfix();
    height: calc(100% - #{$input-height});
    overflow: auto;
    margin: 0 auto;

    position: relative;
    z-index: 1;
    p {
      margin: 0;
      padding: 0;
    }
    .splash & {
      height: calc(100% - 60px);
      overflow: hidden;
    }
  }

  @include e("wrapper") {
    @include clearfix();
    margin: 0 auto;
    padding: 10px;
    max-width: $chat-max-width;
    height: 80%;
  }

  @include e("date") {
    font-size: 12px;
    color: #B5BDC6;
    text-align: center;
    padding: 5px 0;
    text-transform: uppercase;
  }

  @include e("input") {
    //height: 50px;
    max-width: $chat-max-width;
    align-items: center;
    margin: 0 auto;
    //padding: 0 10px 0 10px;
    display: flex;
    position: relative;
    z-index: 1;
    caret-color: #9F48F7;
    @include transition(background 0.5s ease-in-out);
    @include e("text") {
      flex: 4;
      padding: 5px 20px;
      //margin-right: 14px;
      height: 40px;
      background-color: #f2f5fa;
      border-radius: 25px;
      border: none;
      outline: none;
      font-size: 16px;
      @include transition(background 0.5s ease-in-out);
      &::placeholder {
        color: #BDBDBD
      }
    }
    @include e("button") {
      width: 30px;
      padding: 10px 0 0 0;
    }
  }

  .menu-show + .bot-content__input {
    background: #F2F5FA;

    .bot-content__input__text {
      background: #fff;
      color: #ccc;
    }
  }
}
</style>
